module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dy-item-wrap', {
    attrs: {
      "item": _vm.item
    }
  }, [_c('el-date-picker', _vm._g(_vm._b({
    staticClass: "date-separator",
    attrs: {
      "type": _vm.item.subtype,
      "format": _vm.item.viewFormat || _vm.item.valueFormat,
      "clearable": false,
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "default-time": ['00:00:00', '23:59:59']
    }
  }, 'el-date-picker', _vm.$attrs, false), _vm.$listeners))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ced92456"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/widgets/DateRangeWidget.vue
// module id = 728
// module chunks = 20